













import { PropType } from 'vue';
import { EventRefined } from '@fullcalendar/core/internal';
import { calendarUtil } from '../../../shared/utils/calendarUtil';

export default {
  props: {
    eventModel: { type: Object as PropType<EventRefined>, required: true },
  },
  computed: {
    creatorName() {
      return this.eventModel.extendedProps.creatorName;
    },
    location() {
      return calendarUtil.getPrimaryLocation(this.eventModel.extendedProps);
    },
  },
};
